import React from "react";
import { PROFESSIONS } from "../lib/professions";
import { Check } from "@phosphor-icons/react";

export function ProfessionPicker({ value, onChange, compact = false }) {
  return (
    <div className={`grid gap-2 ${compact ? "grid-cols-3 sm:grid-cols-4" : "grid-cols-2 sm:grid-cols-3"}`} data-testid="profession-picker">
      {PROFESSIONS.map((p) => {
        const active = value === p.key;
        return (
          <button
            key={p.key}
            type="button"
            onClick={() => onChange(p.key)}
            data-testid={`profession-${p.key}`}
            style={active ? { borderColor: p.color, backgroundColor: `${p.color}14` } : undefined}
            className={`relative flex flex-col items-center gap-1.5 rounded-lg border p-3 text-center transition hover:border-slate-400 ${active ? "shadow-sm" : "border-slate-200 bg-white"}`}
          >
            {active && <span className="absolute top-1.5 right-1.5 w-4 h-4 rounded-full flex items-center justify-center text-white" style={{ backgroundColor: p.color }}><Check size={10} weight="bold" /></span>}
            <span className="w-9 h-9 rounded-md flex items-center justify-center text-white" style={{ backgroundColor: p.color }}>
              <p.icon size={20} weight="duotone" />
            </span>
            <span className={`text-xs font-medium leading-tight ${active ? "text-slate-900" : "text-slate-700"}`}>{p.label}</span>
          </button>
        );
      })}
    </div>
  );
}
